<script >
import EditIcon from "../icons/EditIcon.vue";
import DefaultTitle from "../small_components/DefaultTitle.vue";
import BadgeBlock from "../slots/BadgeBlock.vue";
import DefaultInput from "../small_components/DefaultInput.vue";
import RouterLinkTo from "../small_components/RouterLinkTo.vue";
import {axiosExport} from "../../helpers/axios_requests";
import DefaultSelect from "../small_components/DefaultSelect.vue";
import dateMixin from "../../mixins/dateMixin";
import {ValidationProvider, extend, ValidationObserver  } from "vee-validate";
import { required, length } from 'vee-validate/dist/rules';
import DefaultButton from "../small_components/DefaultButton.vue";
import DangerButton from "../small_components/DangerButton.vue";
import {FORMAT_ERROR_MESSAGE} from "../../helpers/validation_error_message";
import {STATUS_ERROR} from "../../store/modules/notifiocation";
import {mapActions} from "vuex";
import DefaultBox from "../slots/DefaultBox";

extend('minmax', {
  validate(date, { min, max }) {
    return date.length >= min && date.length <= max;
  },
  params: ['min', 'max'],
  message: 'The {_field_} field must have at least {min} characters and {max} characters at most'
});
extend('required', {
  ...required,
  message: 'This field is required'
});
extend('length', {
  ...length,
  message: 'This field must be'
});

export default {
  name: 'ExportLayout',
  mixins: [dateMixin],
  components: {
    DangerButton,
    DefaultButton,
    DefaultSelect, RouterLinkTo, DefaultInput, BadgeBlock, DefaultTitle, EditIcon, ValidationProvider, ValidationObserver, DefaultBox},
  computed: {
    types() {
      return [
        {
          id: 1,
          title: 'Daily Report'
        },
        {
          id: 2,
          title: 'Timesheet Plan'
        }
      ]
    },
  },
  beforeMount() {
  },

  data() {
    return {
      getUserRoleIsAdmin: true,
      loading: true,
      date: null,
      start_date: null,
      end_date: null,
      reports: [],
      filesPath: null,
      type: '',
    }
  },

  created() {
    this.getFilesPath();
    this.loading = false;
    this.setDate();
    this.loadReports();
  },

  methods: {
    ...mapActions([
      'actionPushNotification'
    ]),
    setDate() {
      this.date = this.date = this.getDateFormatStr(new Date(), '-')
    },
    onSubmit() {
    },
    generateDaily() {
      axiosExport.generateDaily({date: this.date})
          .then(r => {
            if (r.data.errors) {
              this.$refs.form.setErrors(r.data.errors);
              let message = FORMAT_ERROR_MESSAGE(r.data.errors)
              this.actionPushNotification(
                  {message: message, status: STATUS_ERROR}
              )
              return;
            }
            this.loadReports()
          })
    },
    generateSiteStatus() {
      axiosExport.generateSiteStatus({start_date: this.start_date, end_date: this.end_date})
          .then(r => {
            if (r.data.errors) {
              this.$refs.form.setErrors(r.data.errors);
              let message = FORMAT_ERROR_MESSAGE(r.data.errors)
              this.actionPushNotification(
                  {message: message, status: STATUS_ERROR}
              )
              return;
            }
            this.loadReports()
          })
    },
    getFilesPath() {
      axiosExport.path()
          .then(r => {
            this.filesPath = r.data.path;
          })
    },
    download(report) {
      axiosExport.download(
          {filename: report},
          {responseType: 'blob',},
          {
            'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': ' GET, PUT, POST, DELETE, OPTIONS',
                'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token',
                'Access-Control-Allow-Credentials': 'false',
          }
      )
          .then(r => {
            console.log(r.data.file)
            this.downloadFile(r, report)
          })
    },
    downloadFile(response, title) {
      let blob = new Blob([response.data], {
        type: 'application/pdf'
      })
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = title
      link.click()
    },
    deleteReport(report) {
      axiosExport.delete({filename: report})
          .then(r => {
            if (r.data.errors) {
              this.$refs.form.setErrors(r.data.errors);
              let message = FORMAT_ERROR_MESSAGE(r.data.errors)
              this.actionPushNotification(
                  {message: message, status: STATUS_ERROR}
              )
              return;
            }
            this.loadReports()
          })
    },
    loadReports() {
      this.loading = true
      axiosExport.list({size: 100})
          .then(r => {
            this.fillReports(r.data)
          })
          .finally(() => {
            this.loading = false
          })
    },
    fillReports(data) {
      this.reports = data;
    },
    changeType(type) {
      this.type = type.title;
    },
    generateDownloadLink(item) {
      return window.location.origin + '/uploads/reports/'+item;
    }
  }
}

</script>

<template>
  <div class="dashboard-layout">
    <badge-block>
      <default-title h_tag="h3">
        {{ $t('export.reports_generation') }}
      </default-title>
      <default-box class="position-relative"
                :loader="loading">
        <ValidationObserver v-slot="{ invalid, passes }" ref="form">
        <form class="row dashboard-wrapper  mt-20" @submit.prevent="passes(onSubmit)">
          <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
            <div class="card">
              <h5 class="card-header">{{ $t('export.generate_new_report') }}</h5>
              <div class="card-body">
                  <div
                      class="col-md-12 col-12 mb-10">
                    <default-select
                        :placeholder="$t('export.select_report_type')"
                        display_item_api_key="title"
                        :selected_val="type"
                        @change="changeType"
                        :list_outer="types"
                    />
                  </div>
                <template class="row mt-20" v-if="type === 'Daily Report'">
                  <div class="col-md-6 col-12 mb-10">
                    <label class="default-input">
                      <span title="Manager" class="default-input__label">
                        {{ $t('inputs.select_date') }}
                      </span>
                      <ValidationProvider rules="required|length:10" vid="date" name="date" v-slot="{ errors }">
                      <input type="date"
                           v-model="date"
                             name="date">
                        <span>{{ errors[0] }}</span>
                      </ValidationProvider>
                    </label>
                  </div>
                  <div class="col-md-12 col-12 mb-10">
                    <label class="default-input default-input__date">
                      <default-button
                          :disabled="invalid"
                          button_smaller
                          class="w-100"
                          type="submit"
                          @click="generateDaily()">
                        {{ $t('inputs.generate') }}
                      </default-button>
                    </label>
                  </div>
                </template>
                <template v-if="type === 'Timesheet Plan'">
                  <div class="col-md-12 col-12 mb-10">
                    <label class="default-input default-input__date">
                      <span  class="default-input__label">
                        {{ $t('inputs.start_date') }}
                      </span>
                      <ValidationProvider rules="required|length:10" vid="start_date" name="start_date" v-slot="{ errors }">
                      <input type="date"
                             min='2019-01-01'
                             max='2029-01-01'
                             v-model="start_date">
                        <span>{{ errors[0] }}</span>
                      </ValidationProvider>
                    </label>
                  </div>
                  <div class="col-md-12 col-12 mb-10">
                    <label class="default-input default-input__date">
                      <span class="default-input__label">
                        {{ $t('inputs.end_date') }}
                      </span>
                      <ValidationProvider rules="required|length:10" vid="end_date" name="end_date" v-slot="{ errors }">
                      <input type="date"
                             min='2014-01-01'
                             max='2029-01-01'
                             v-model="end_date">
                        <span>{{ errors[0] }}</span>
                      </ValidationProvider>
                    </label>
                  </div>
                  <div class="col-md-6 col-12 mb-10">
                    <label class="default-input">
                      <default-button
                          :disabled="invalid"
                          button_smaller
                          class="w-100"
                          type="submit"
                          @click="generateSiteStatus()">
                        {{ $t('inputs.generate') }}
                      </default-button>
                    </label>
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12" >
            <div class="card" v-if="reports.length > 0">
              <h5 class="card-header">{{ $t('export.ready_for_export') }}</h5>
              <div class="card-body">
                <div class="table-responsive ">
                  <table class="table">
                    <thead>
                    <tr>
                      <th scope="col">{{ $t('inputs.name') }}</th>
                      <th scope="col">{{$t('tables.actions')}}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(report, key) in reports" :key="key">
                      <td><span>{{ report }}</span></td>
                      <td>
                        <default-button
                            class="w-100 btn-link"
                            button_smaller
                            type="submit"
                            >
                          <a :href="generateDownloadLink(report)" :style="'color: white'" target="_blank" download>{{$t('inputs.download')}}</a>
                        </default-button>
                        <danger-button
                            class="w-100"
                            button_smaller
                            type="submit"
                            @click="deleteReport(report)">
                          {{$t('inputs.delete')}}
                        </danger-button>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div class="card" v-else>
              <h5 class="card-header">{{ $t('export.there_are_no_reports') }}</h5>
              <div class="card-body">
              </div>
            </div>
          </div>
        </form>
        </ValidationObserver>
      </default-box>
    </badge-block>
  </div>
</template>

<style scoped>

</style>